import React from "react";
import Navbar from "../features/Navbar/Navbar";
import ProductForm from "../features/admin/Component/ProductForm";

export default function ProductFormPage() {
  return (
    <>
      <Navbar></Navbar>
      <ProductForm></ProductForm>
    </>
  );
}
